<template>
    <div v-show="loaded">
        <b-form-row>
            <b-form-group
                class="mb-0"
                :label="$t('Scelta della modalità consegna')"
                label-class="h6"
            >
                <b-form-checkbox-group
                    v-model="settings.deliveryType"
                    name="deliveryType"
                    :state="deliveryTypeValidation"
                >
                    <b-form-checkbox
                        v-for="deliveryOption in deliveryTypeOptions"
                        :key="deliveryOption.value"
                        :value="deliveryOption.value"
                    >
                        {{$t(deliveryOption.text)}}
                    </b-form-checkbox>
                    <b-form-invalid-feedback :state="deliveryTypeValidation">
                        {{ $t("Seleziona una modalità di consegna") }}
                    </b-form-invalid-feedback>
                </b-form-checkbox-group>
            </b-form-group>
        </b-form-row>

        <b-form-row>
            <b-form-group
                v-show="showPaymentTypeShop()"
                class="mb-0 mt-3"
                :label="$t('Scelta della modalità di pagamento per la consegna presso punto vendita')"
                label-class="h6"
            >
                <b-form-checkbox-group
                    v-model="settings.paymentTypeShop "
                    name="paymentTypeShop"
                    :state="paymentTypeShopValidation"
                >
                    <b-form-checkbox
                        v-for="paymentTypeShopOption in paymentTypeShopOptions"
                        :key="paymentTypeShopOption.value"
                        :value="paymentTypeShopOption.value"
                    >
                        {{$t(paymentTypeShopOption.text)}}
                    </b-form-checkbox>
                    <b-form-invalid-feedback :state="paymentTypeShopValidation">
                        {{ $t("Seleziona una modalità di pagamento") }}
                    </b-form-invalid-feedback>
                </b-form-checkbox-group>
            </b-form-group>
        </b-form-row>

        <b-form-row>
            <b-form-group
                v-show="showPaymentTypeHome()"
                class="mb-0 mt-3"
                :label="$t('Scelta della modalità di pagamento per la consegna a domicilio')"
                label-class="h6"
            >
                <b-form-checkbox-group
                    v-model="settings.paymentTypeHome "
                    name="paymentTypeHome"
                    :state="paymentTypeHomeValidation"
                >
                    <b-form-checkbox
                        v-for="paymentTypeHomeOption in paymentTypeHomeOptions"
                        :key="paymentTypeHomeOption.value"
                        :value="paymentTypeHomeOption.value"
                    >
                        {{$t(paymentTypeHomeOption.text)}}
                    </b-form-checkbox>
                    <b-form-invalid-feedback :state="paymentTypeHomeValidation">
                        {{ $t("Seleziona una modalità di pagamento") }}
                    </b-form-invalid-feedback>
                </b-form-checkbox-group>
            </b-form-group>
        </b-form-row>

        <b-form-row>
            <b-form-group
                v-show="showPaypalAccountEmail()"
                class="mb-0 mt-3"
                :label="$t('Inserisci la email del tuo account Paypal')"
                label-class="h6"
                :state="paypalAccountEmailValidation"
            >
                <b-form-input
                    class="rounded-pill rilievo-ombra-interna"
                    type="email"
                    v-model="settings.paypalAccountEmail"
                    trim
                ></b-form-input>
                <b-form-invalid-feedback :state="paypalAccountEmailValidation">
                    {{ $t("Inserisci l'email account Paypal") }}
                </b-form-invalid-feedback>
            </b-form-group>
        </b-form-row>

        <b-form-row>
            <b-form-group
                v-show="showInvoiceFlag()"
                class="mb-0 mt-3"
                :label="$t('Scelta per richiesta obbligatoria dei dati fattura per ordini pagati online')"
                label-class="h6"
            >
                <b-form-row>
                    <b-form-checkbox
                        class="ml-1 w-75"
                        v-model="settings.flagFattura"
                        name="flagFattura"
                    >
                        {{$t('Richiedi obbligatoriamente i dati per la fatturazione')}}
                    </b-form-checkbox>
                    <font-awesome-icon
                        class="ml-2 mt-1"
                        :icon="['fas', 'question-circle']"
                        v-b-modal.invoice-modal
                    />
                </b-form-row>
            </b-form-group>
        </b-form-row>

        <b-modal
            id="invoice-modal"
            :title="$t('Richiesta dati fatturazione')"
            centered
            size="lg"
            ok-only
        >
            <div class="mb-1">
                Abilitando questa opzione, solo per gli ordini con pagamento anticipato: al cliente finale verrà richiesto l’inserimento del codice fiscale, ed in caso di azienda della partita iva e codice identificativo di fatturazione, in modo che risulti più comodo la gestione manuale, da parte del fotografo, della fattura immediata, necessaria per queste attività.
            </div>
            <div class="mb-1">
                Il sistema RikordaEventi invierà una email di pro-memoria al fotografo con i dati anagrafici del cliente e i riferimenti dell’ordine, in modo che il fotografo possa provvedere, con il proprio sistema di fatturazione, all’emissione della fattura immediata.
            </div>
            <div>
                E’ consigliato rivolgersi al proprio consulente fiscale per approfondimenti in materia di adempimenti su e-commerce e pratiche necessarie per consegne a domicilio e pagamenti anticipati.
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "SettingsDeliveryAndPaymentsSection",
    props: ["settings"],

    data() {
        return {
            loaded: false,
            deliveryTypeOptions: [
                { value: "SHOP", text: "Presso punto vendita" },
                { value: "HOME", text: "A domicilio" }
            ],
            paymentTypeShopOptions: [
                { value: "CASH", text: "Presso punto vendita" },
                { value: "PAYPAL", text: "Paypal" }
            ],
            paymentTypeHomeOptions: [{ value: "PAYPAL", text: "Paypal" }]
        };
    },

    computed: {
        isValid() {
            return (
                this.deliveryTypeValidation &&
                this.paymentTypeShopValidation &&
                this.paymentTypeHomeValidation &&
                this.paypalAccountEmailValidation
            );
        },
        deliveryTypeValidation() {
            var validate = this.loaded;
            return validate ? this.settings.deliveryType.length > 0 : true;
        },
        paymentTypeShopValidation() {
            var validate =
                this.loaded && this.settings.deliveryType.indexOf("SHOP") > -1;
            return validate ? this.settings.paymentTypeShop.length > 0 : true;
        },
        paymentTypeHomeValidation() {
            var validate =
                this.loaded && this.settings.deliveryType.indexOf("HOME") > -1;
            return validate ? this.settings.paymentTypeHome.length > 0 : true;
        },
        paypalAccountEmailValidation() {
            var validate = this.showPaypalAccountEmail();
            return validate
                ? this.settings.paypalAccountEmail.length > 0
                : true;
        }
    },

    methods: {
        showPaymentTypeShop() {
            var show = false;
            if (this.loaded) {
                if (this.settings.deliveryType.indexOf("SHOP") > -1) {
                    show = true;
                }
            }
            return show;
        },

        showPaymentTypeHome() {
            var show = false;
            if (this.loaded) {
                if (this.settings.deliveryType.indexOf("HOME") > -1) {
                    show = true;
                }
            }
            return show;
        },

        showPaypalAccountEmail() {
            var show = false;
            if (this.loaded) {
                if (
                    this.settings.deliveryType.indexOf("SHOP") > -1 &&
                    this.settings.paymentTypeShop.indexOf("PAYPAL") > -1
                ) {
                    show = true;
                }
                if (
                    this.settings.deliveryType.indexOf("HOME") > -1 &&
                    this.settings.paymentTypeHome.indexOf("PAYPAL") > -1
                ) {
                    show = true;
                }
            }
            return show;
        },

        showInvoiceFlag() {
            let show = this.showPaypalAccountEmail();
            if (this.loaded && !show) {
                this.settings.flagFattura = false;
            }
            return show;
        }
    }
};
</script>

<style></style>
